import React, { useState, useEffect } from 'react';
import { db } from '../../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { Link, useParams } from 'react-router-dom';
import { Drawer, List, ListItem, Typography } from '@mui/material';

const ChatGroups = () => {
  const { userId } = useParams();  // Get userId from URL
  const [groups, setGroups] = useState([]);

  // Fetch chat groups on component mount
  useEffect(() => {
    async function fetchChatGroups() {
      const chatGroupsCollection = collection(db, 'chatGroups');
      const chatGroupsSnapshot = await getDocs(chatGroupsCollection);
      const chatGroupsList = chatGroupsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setGroups(chatGroupsList);
    }
    fetchChatGroups();
  }, []);

  return (
    <Drawer variant="permanent" anchor="center" sx={{
      width: 300,
      flexShrink: 0,
      margin: '0 auto',
      backgroundColor:"black"
    }}>
      <Typography variant="h4" sx={{marginTop:10 ,textAlign: 'center', padding: 2, color: 'black' }}>
        Chat Rooms
      </Typography>
      <List sx={{ padding: 2, textAlign: 'center' }}>
        {groups.map(group => (
          <ListItem
            key={group.id}
            sx={{
              justifyContent: 'center',
              backgroundColor: 'primary.main',
              borderRadius: 4,
              padding: 1,
              margin: 1,
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            <Link to={`/chat/${userId}/${group.id}`} sx={{ textDecoration: 'none', color: 'white' }}>
              {group.name}
            </Link>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default ChatGroups;